import moment from "moment";

/**
 * Sorts an array of objects by the 'createdAt' property in descending order.
 * Each object in the array is expected to have a 'createdAt' property
 * which is a date string or a Date object.
 * @param {Array} array - The array of objects to be sorted.
 * @returns {Array} - The sorted array, with the most recent 'createdAt' dates first.
 */
export default function sortByCreatedAt(array, order = "desc") {
  if (!Array.isArray(array) || array.length === 0) return [];

  return array.sort((a, b) => {
    // Sort by createdAt in descending or ascending order
    return (b.createdAt - a.createdAt) * (order === "desc" ? 1 : -1);
  });
}
